export default __webpack_public_path__ + "static/media/isotype-white.10e60ef0.svg";